const PROD_DESCRIPTION = '.product-description__content';
const READ_MORE_BUTTON = '.product-description__read-more';
const HIDE_VISIBILITY = 'hide-visibility';

function initReadMoreButton(): void {
  const readMoreParagraphsCount = document.querySelector<HTMLElement>(PROD_DESCRIPTION)?.childElementCount;
  const readMoreButton = document.querySelector<HTMLElement>(READ_MORE_BUTTON);

  if (readMoreButton && readMoreParagraphsCount && readMoreParagraphsCount > 1) {
    readMoreButton.classList.remove(HIDE_VISIBILITY);
  }
}

export default initReadMoreButton;
